import {bootstrap} from "vue-gtag";
<template>
  <div>
    <BIconHeartFill
      v-if="isWishlisted(product)"
      @click.stop="toggle(product)"
      class="wishlist-icon"
    />
    <BIconHeart v-else @click.stop="toggle(product)" class="wishlist-icon" />
  </div>
</template>

<script>
import { BIconHeart, BIconHeartFill } from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "wishlist-component",
  components: {
    BIconHeart,
    BIconHeartFill
  },
  props: {
    product: {
      required: true,
      type: Object
    }
  },
  methods: {
    toggle(product) {
      if (this.$cookies.get("accept-cookie-policy")) {
        this.isWishlisted(product)
          ? this.$gtag.event("productWishlisted", {
              value: product._id,
              event_category: "wishlist",
              event_label: "product"
            })
          : this.$gtag.event("productWishlistRemoved", {
              value: product._id,
              event_category: "wishlist",
              event_label: "product"
            });
      }
      this.toggleProduct(product);
    },
    ...mapActions({
      toggleProduct: "wishlist/toggleProduct"
    })
  },
  computed: {
    ...mapGetters({
      isWishlisted: "wishlist/isItemWishlisted"
    })
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.wishlist-icon {
  color: $gyra-salmon;
  font-weight: 600;
  padding: 5px;
  font-size: inherit !important;
}
</style>
